// extracted by mini-css-extract-plugin
module.exports = {"container":"_82e3db2ea0--container--e9sYT","phone":"_82e3db2ea0--phone--z4fra","content":"_82e3db2ea0--content--MK3b4"};